"use strict";

import Dom from "common/Dom";
export const setFirstActive = function setFirstActive() {
  $(Dom.tab).first().addClass("is-active");
};
export const setActiveTab = function setActiveTab() {
  var activeTab = $("[data-tab].is-active");
  var activeTabAttr = activeTab.attr("data-tab");
  $("[data-tab-content='" + activeTabAttr + "']").addClass("is-active");
  $(Dom.tabHeading).text(activeTabAttr);
};
export const toggleClasses = function toggleClasses($el) {
  var tabs = $el.closest($(Dom.tabContainer)).find($(Dom.tab));
  var tabContent = $el.closest($(Dom.tabContainer)).find($(Dom.tabContent));
  var activeTabAttr = $el.attr("data-tab");
  tabs.removeClass("is-active");
  tabContent.removeClass("is-active");
  $el.addClass("is-active");
  $("[data-tab-content='" + activeTabAttr + "']").addClass("is-active");
  $(Dom.tabHeading).text(activeTabAttr);
};
